import { DS_DIRECTION, type DSDirection } from "@/src/design_system/shared/types/direction";
import { DS_DIVIDER_SEVERITY, type DSDividerSeverity } from "../types/severity";

export const DS_DIVIDER_CLASSES = {
  Root: "ds-divider",
  Line: "ds-divider__line",
  Label: "ds-divider__label",
  OrientationHorizontal: "ds-divider--horizontal",
  OrientationVertical: "ds-divider--vertical",
  SeverityDefault: "ds-divider--default",
  SeveritySoft: "ds-divider--soft",
  SeverityAccent: "ds-divider--accent",
} as const;

export const DS_DIVIDER_DIRECTION_TO_CLASS_MAP: Record<DSDirection, string> = {
  [DS_DIRECTION.Horizontally]: DS_DIVIDER_CLASSES.OrientationHorizontal,
  [DS_DIRECTION.Vertically]: DS_DIVIDER_CLASSES.OrientationVertical,
};

export const DS_DIVIDER_SEVERITY_TO_CLASS_MAP: Record<DSDividerSeverity, string> = {
  [DS_DIVIDER_SEVERITY.Default]: DS_DIVIDER_CLASSES.SeverityDefault,
  [DS_DIVIDER_SEVERITY.Soft]: DS_DIVIDER_CLASSES.SeveritySoft,
  [DS_DIVIDER_SEVERITY.Accent]: DS_DIVIDER_CLASSES.SeverityAccent,
};
